import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomainUtilService {

  constructor() { }


  getSONameBasedOnType(domain): string {
    if (domain != null) {
      return domain.type === "COUNTRY_CODE" ? "ccTLD Manager" : "Registry Operator";
    }
  }
}
